import EmployeeName from "@/model/EmployeeName";
import OrderName from "@/model/OrderName";

export default class PerDiem {
  public id?: number | null;

  public uuid?: string;

  public employee: EmployeeName;

  public order: OrderName;

  public date: string;

  /**
   * Null while several selected per diems differ in it, so it has to be chosen before saving.
   */
  public misc: number | null;

  /**
   * Null while several selected per diems differ in it, so it has to be chosen before saving.
   */
  public catering: number | null;

  public calculatedCatering: number;

  /**
   * Null while several selected per diems differ in it, so it has to be chosen before saving.
   */
  public breakfast: boolean | null;
}
